export default __webpack_public_path__ + "static/media/mobileBottom.97b6fbb9.svg";